"use client";

import React, { useEffect } from "react";
import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { HeroSection } from "@/components/sections/hero-section";
import { MissionSection } from "@/components/sections/mission-section";
import { ImpactSection } from "@/components/sections/impact-section";
import { InitiativesSection } from "@/components/sections/initiatives-section";
import { TeamSection } from "@/components/sections/team-section";
import { NewsSection } from "@/components/sections/news-section";
import { TestimonialsSection } from "@/components/sections/testimonials-section";
import { ContactSection } from "@/components/sections/contact-section";
import { CTASection } from "@/components/sections/cta-section";

export default function Home() {
  // Initialize intersection observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("appear");
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all elements with the animation classes
    document.querySelectorAll(".slide-in, .fade-in, .scale-in").forEach((el) => {
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <MissionSection />
        <ImpactSection />
        <InitiativesSection />
        <TeamSection />
        <TestimonialsSection />
        <NewsSection />
        <ContactSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}